/** Per-row revisions: task and output counters are separate, never wall clocks. */
export class TaskEventVersions {
  private readonly versions = new Map<string, bigint>();
  accept(event: Record<string, unknown>): boolean {
    if (typeof event.taskId !== 'string' || !event.taskId) return false;
    if (event.outputId !== undefined && typeof event.outputId !== 'string') return false;
    const key = event.outputId ? `output:${event.outputId}` : `task:${event.taskId}`;
    const previous = this.versions.get(key);
    // Old servers are compatible during rollout; their events only invalidate.
    if (event.revision === undefined) return previous === undefined;
    if (typeof event.revision !== 'string' || !/^\d{1,20}$/.test(event.revision)) return false;
    const revision = BigInt(event.revision);
    if (previous !== undefined && revision <= previous) return false;
    this.versions.delete(key);
    this.versions.set(key, revision);
    if (this.versions.size > 5_000) this.versions.delete(this.versions.keys().next().value!);
    return true;
  }
  clear() { this.versions.clear(); }
}
